import React from "react";
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import { Tooltip, Button } from "@material-ui/core";

export default function Edit(props) {
    return (
        <Tooltip title={<span style={{ fontSize: 15 }}> Editar </span>} >
            <Button
                onClick={() => {
                    props.setData(props.data)
                    props.setOpen(true)
                }}
                size="small"
            >
                <EditIcon />
            </Button>
        </Tooltip>
    );
}

Edit.propTypes = {
    data: PropTypes.object,
    setData: PropTypes.func,
    setOpen: PropTypes.func,
};
